import { get } from './ajax';
import { HeaderVarnish } from '../../Settings/global/nota.json'

function getDefaultDataUrl(url = '') {
    if (url.indexOf('?') >= 0) {
        return url + '&utm_source=navigation';
    }
    return url + '?utm_source=navigation';
}

export function loadData(url, getDataUrl = getDefaultDataUrl) {
    const dataUrl = getDataUrl(url);
    return new Promise((resolve, reject) => {
        get(dataUrl).then((rs) => {
            const data = JSON.parse(rs);
            const elements = [];
            for (let i = 0; i < data.Modules.length; i++) {
                const m = data.Modules[i];
                const el = document.querySelector(`[data-module="${m.Key}"]`);
                el.innerHTML = m.Value;
                elements.push(el);
            }
            document.title = data.Title;
            resolve(elements);
        })
            .catch(() => reject());
    });
}

export function signwall() {
    let signwall = HeaderVarnish.filter(x => x.key == "X-APW-AUTHENTICATION-FAILED");
    return signwall.value.replace("{url}", "");
}

export function paywall() {
    let signwall = HeaderVarnish.filter(x => x.key == "X-APW-AUTHORIZATION-DENIED");
    return signwall.value.replace("{url}", "");
}

window.prueba11 = function() {
    console.log("entre a PRUEBA11111111");
}





// WEBPACK FOOTER //
// ./Statics/pwa/page.js